import React from 'react';
import localStrings from "../../localStrings";
import GenericSparkDataSpark from "./GenericSparkDataSpark";
import EuroIcon from "@mui/icons-material/Euro";
import {useMediaQuery} from "@mui/material";
import OrderIcon from "../../icons/untitled-ui/duocolor/order";

function OrdersSpark({modeGraph}) {

    const lgUp = useMediaQuery((theme) => theme.breakpoints.up("lg"));
    // Force graph mode for testing - change to md or sm for lower screen sizes
    const forceGraphMode = useMediaQuery((theme) => theme.breakpoints.up("md"));
    return (
        <>
            <GenericSparkDataSpark
                modeGraph={forceGraphMode}
                getterData={(data) => data?.totalOrders}
                title={localStrings.totalOrders}
                icon={<OrderIcon/>}
                backgroundColor={(theme) => theme.palette.mode === 'dark'
                    ? 'neutral.800'
                    : 'warning.lightest'}
            />
        </>
    )
}

export default OrdersSpark